import React from "react";
import styles from "./PrivacyPolicy.module.css";
import { ContactData } from "../../controller/ContactData";

const PrivacyPolicy = () => {
  // Separate email and address from ContactData
  const email = ContactData.find((item) => item.id === 1)?.text;
  const phone = ContactData.find((item) => item.id === 2)?.text;
  const address = ContactData.find((item) => item.id === 3)?.text;
  const effectiveDate = "16/10/2025";

  const sections = [
    {
      title: "1. Scope and Purpose",
      content: [
        "The Holy Bharat Platform is a digital initiative by Bharat Clouds Private Limited designed to provide information and community engagement around temples across India. Users may access, explore, and contribute information through the Platform.",
        "This Privacy Policy governs how user information is collected, processed, stored, and protected while using the Platform.",
      ],
    },
    {
      title: "2. Information We Collect",
      content: [
        "We collect and process user information necessary to provide and improve the Platform and related services.",
        "This includes:",
      ],
      list: [
        "Information provided during registration or use of the Platform.",
        "Information submitted as part of temple contributions or community interactions.",
        "Information collected automatically, such as device details, browser type, IP address, approximate location, and usage data.",
        "Information received from authentication providers when users log in via third-party platforms such as Facebook, LinkedIn, Google, etc.",
      ],
      content2: [
        "We collect only the information relevant to facilitate account creation, authentication, and the smooth functioning of Platform features.",
      ],
    },
    {
      title: "3. Use of Information",
      content: [
        "The information collected is used for the following purposes:",
      ],
      list: [
        "To create, verify, and manage user accounts.",
        "To enable the submission, display, and management of temple-related content.",
        "To authenticate users through integrated login providers.",
        "To communicate updates, notifications, or relevant information to users.",
        "To improve Platform functionality, user experience, and performance.",
        "To comply with applicable legal and regulatory obligations.",
      ],
      content2: [
        "We do not share user information with third parties for profit, promotion, or any transactional purpose.",
      ],
    },
    {
      title: "4. Data Sharing and Disclosure",
      content: [
        "User information may be shared only under the following conditions:",
      ],
      list: [
        "Service Providers: With trusted vendors or partners who assist in hosting, analytics, communication, or technical operations.",
        "Legal Requirements: When disclosure is necessary to comply with applicable laws, legal processes, or government requests.",
        "Business Transactions: In case of a merger, acquisition, or restructuring involving Bharat Clouds Private Limited, subject to continued protection of user information.",
        "Public Contributions: Temple-related information submitted voluntarily by users may be displayed publicly on the Platform. Personal contact or identifiable information will not be shared without consent.",
      ],
    },
    {
      title: "5. Social Login Integration",
      content: [
        "The Platform supports authentication through Facebook, LinkedIn, and Google. When users choose these options, limited data required for identity verification and account setup is retrieved from the respective service providers.",
        "The use of information by these third-party providers is governed by their respective privacy policies. Users are encouraged to review them before proceeding with social logins.",
      ],
    },
    {
      title: "6. Cookies and Tracking Technologies",
      content: [
        "The Platform uses cookies and similar technologies to enhance functionality and user experience.",
        "These tools help:",
      ],
      list: [
        "Maintain user sessions;",
        "Analyze usage patterns;",
        "Improve content delivery and interface performance.",
      ],
      content2: [
        "Users can disable cookies through their browser or device settings, although certain Platform features may not operate optimally as a result.",
      ],
    },
    {
      title: "7. Data Security",
      content: [
        "We adopt reasonable administrative, technical, and physical safeguards to protect user information from unauthorized access, alteration, or destruction.",
        "While every effort is made to ensure data security, users acknowledge that no digital transmission or storage system can be guaranteed to be completely secure.",
      ],
    },
    {
      title: "8. Data Retention",
      content: [
        "User information is retained only for as long as necessary to provide services, comply with legal obligations, or resolve disputes.",
        "Upon verified request from a user, data may be deleted or anonymized unless retention is legally required.",
      ],
    },
    {
      title: "9. User Rights",
      content: [
        "Users may exercise certain rights with respect to their information, including:",
      ],
      list: [
        "Accessing or updating stored information;",
        "Requesting deletion of account and related data;",
        "Withdrawing consent for specific data uses;",
        "Opting out of non-essential communications.",
      ],
      content2: [
        "Requests can be made by contacting info@bharatclouds.com.",
        " We will verify and respond to all legitimate requests within a reasonable period.",
      ],
    },
    {
      title: "10. Third-Party Services",
      content: [
        "The Platform may include or integrate with third-party tools, including:",
      ],
      list: [
        "Mapping and location services (e.g., Google Maps);",
        "Social authentication providers (e.g., Facebook, LinkedIn, Google);",
        "Analytics and hosting platforms.",
      ],
      content2: [
        "These entities operate independently and have their own privacy policies. Bharat Clouds Private",
        "Limited does not assume responsibility for their data practices.",
      ],
    },
    {
      title: "11. Children’s Privacy",
      content: [
        "The Holy Bharat platform isn’t meant for use by children. We don’t collect their personal information, and if any such data is found, it will be promptly deleted. ",
      ],
    },
    {
      title: "12. Changes to This Policy",
      content: [
        "This Privacy Policy may be updated periodically to reflect changes in technology, legal obligations, or operational practices. The revised version will be posted on the Platform with an updated effective date. Continued use of the Platform constitutes acceptance of any changes.",
      ],
    },
    {
      title: "13. Governing Law ",
      content: [
        "This Privacy Policy shall be governed by and construed in accordance with the laws of India. All disputes arising hereunder shall be subject to the exclusive jurisdiction of the courts located in Chennai, Tamil Nadu.",
      ],
    },
  ];

  return (
    <div className={`mb-4 ${styles.privacyContainer}`}>
      {/* Breadcrumb */}
      {/* <div className={styles.terms}>
        <ul className="list-unstyled d-flex gap-1 m-0 align-items-center">
          <li>
            <a href="#" className={styles.link}>
              Terms of Use
            </a>
          </li>
          <li>/</li>
          <li>
            <a href="#" className={styles.linkActive}>
              Privacy Policy
            </a>
          </li>
        </ul>
      </div> */}

      {/* Main Heading */}
      <div className={styles.headingContainer}>
        <h2 className={`main_heading ${styles.mainHeading}`}>Privacy Policy</h2>
      </div>
      <div className={styles.effectiveDetails}>
        <div>
          <strong>Effective Date:</strong> {effectiveDate}
        </div>
        <div>
          <strong>Entity:</strong> Bharat Clouds Private Limited
        </div>
        <div>
          <strong>Product:</strong> Holy Bharat
        </div>
      </div>

      <div className={styles.titleWrapper}>
        <h2 className={`${styles.titleHeading}`}>
          This Privacy Policy describes how Bharat Clouds Private Limited
          (“Company”, “we”, “our”, or “us”) collects, uses, shares, and protects
          user information in connection with its product Holy Bharat
          (“Platform”).
        </h2>
      </div>
      <div className={styles.titleWrapper}>
        <h2 className={`${styles.titleHeading}`}>
          By accessing or using the Platform, you acknowledge that you have
          read, understood, and agreed to this Privacy Policy. If you do not
          agree with its terms, you are advised not to use the Platform.
        </h2>
      </div>
      <div className={styles.titleWrapper}>
        <h2 className={`${styles.titleHeading}`}>
          This document is intended to comply with applicable data protection
          laws in India.
        </h2>
      </div>

      {/* Sections */}
      {sections.map((section, index) => (
        <div key={index} className={styles.policySection}>
          <h3>{section.title}</h3>

          {section.content.map((para, i) => (
            <p key={i}>{para}</p>
          ))}

          {section.list && (
            <ul>
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
          {/* Render content2 if present */}
          {section.content2?.map((para, i) => (
            <p key={`content2-${i}`}>{para}</p>
          ))}
        </div>
      ))}
      <div className={styles.contactSection}>
        <h3 className={styles.policySectionH3}>Email:</h3>
        <p className={`py-1 ${styles.policySectionP}`}>{email}</p>

        <h3 className={styles.policySectionH3}>Phone:</h3>
        <p className={`py-1 ${styles.policySectionP}`}>{phone}</p>

        <h3 className={styles.policySectionH3}>Address:</h3>
        <p className={`py-1 ${styles.policySectionP}`}>{address}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
